module.exports = __webpack_public_path__ + "img/DNARepair-LICA_GSE146409.082fdc7a.png";